var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('employee-list',_vm._g({attrs:{"users":_vm.users,"count":_vm.count,"visibilityConfig":_vm.visibilityConfig,"page":_vm.params.page},on:{"updateTable":_vm.onUpdateTable,"refresh":_vm.onRefresh}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }